/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Road_Dude_Faq_Photos_QInputs */

const en_road_dude_faq_photos_q = /** @type {(inputs: Road_Dude_Faq_Photos_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How many photos do I need for a remake?`)
};

const zh_road_dude_faq_photos_q = /** @type {(inputs: Road_Dude_Faq_Photos_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`翻拍需要几张照片？`)
};

/**
* | output |
* | --- |
* | "How many photos do I need for a remake?" |
*
* @param {Road_Dude_Faq_Photos_QInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const road_dude_faq_photos_q = /** @type {((inputs?: Road_Dude_Faq_Photos_QInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Road_Dude_Faq_Photos_QInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_road_dude_faq_photos_q(inputs)
	return zh_road_dude_faq_photos_q(inputs)
});
export { road_dude_faq_photos_q as "road_dude.faq.photos.q" }